import React, { useEffect } from 'react'
import { RenderItemProps } from './types'
import { FeedTextOverlay } from '../molecules/TextOverlay'
import { TextBubble } from '../atoms/TextBubble'
import { DebugItem, FeedDimensions } from './shared'
import { ImmersiveVideo } from '@/components/Player/Immersive'
import { useIsFocusedFeedItem } from '../feedScroll'
import { useMediaQueryDown, useVolume } from '@/utils'
import { videoCache } from '@/utils/videoCache'

export const FeedVideo = (props: RenderItemProps) => {
  const { item, index, contentOverlay } = props

  const isFocused = useIsFocusedFeedItem(index)

  const videoController = ImmersiveVideo.use()
  const interacted = ImmersiveVideo.interactedStore.use()

  const video = item?.post?.video

  const volume = useVolume()

  useEffect(() => {
    if (!interacted) return

    if (isFocused && videoController.loaded) {
      videoController.resume()
    } else {
      videoController.pause()
    }
  }, [isFocused, videoController.loaded, interacted])

  const isSmall = useMediaQueryDown(FeedDimensions.mobileBreakpoint)

  const width = isSmall ? FeedDimensions.WIDTH_WITHOUT_SPACING : FeedDimensions.WIDTH
  const height = isSmall ? FeedDimensions.HEIGHT_WITHOUT_SPACING : FeedDimensions.HEIGHT

  const videoUrl = videoCache.use(item?.id, video)

  return (
    <>
      <DebugItem {...props} />

      {contentOverlay}

      <ImmersiveVideo
        width={width}
        height={height}
        mute={volume.muted}
        volume={volume.muted ? 0 : 1}
        controller={videoController}
      >
        <ImmersiveVideo.Video url={videoUrl} thumbnail={video?.thumbnail} />
        <ImmersiveVideo.Placeholder thumbnail={video?.thumbnail} style={{ width, height }} />
        <ImmersiveVideo.Error />
        {videoController.loaded ? <ImmersiveVideo.Controls /> : null}
      </ImmersiveVideo>
    </>
  )
}
